import {DraaiType, HengType, LuikType} from "../Model";

export function validateAmountWithRotationType(row, draaitype, kozijnen, luiken, direct = false) {
    switch (draaitype) {
        case DraaiType.AL:
        case DraaiType.AR:
        case DraaiType.ALO:
        case DraaiType.ARO:
            return kozijnen !== luiken
                ? [(direct ? "" : `Situatie ${rowLetter(row)}: `) + "U heeft gekozen voor een draaitype waarbij het aantal kozijnen gelijk is aan het aantal luiken. Ingevulde aantal luiken en kozijnen zijn echter niet gelijk."]
                : []
        case DraaiType.B:
        case DraaiType.BLO:
        case DraaiType.BRO:
        case DraaiType.CL:
        case DraaiType.CR:
        case DraaiType.DL:
        case DraaiType.DR:
            return kozijnen * 2 != luiken
                ? [(direct ? "" : `Situatie ${rowLetter(row)}: `) + `U heeft gekozen voor een draaitype waarbij 2 luiken per kozijn toegepast worden. Echter heeft uw situatie ${kozijnen} kozijnen en ${luiken} luiken`]
                : []
        case DraaiType.E:
        case DraaiType.F:
            return kozijnen * 4 != luiken
                ? [(direct ? "" : `Situatie ${rowLetter(row)}: `) + `U heeft gekozen voor een draaitype waarbij 4 luiken per kozijn toegepast worden. Echter heeft uw situatie ${kozijnen} kozijnen en ${luiken} luiken`]
                : []
        case DraaiType.EL:
        case DraaiType.ER:
        case DraaiType.FL:
        case DraaiType.FR:
            return kozijnen * 3 != luiken
                ? [(direct ? "" : `Situatie ${rowLetter(row)}: `) + `U heeft gekozen voor een draaitype waarbij 3 luiken per kozijn toegepast worden. Echter heeft uw situatie ${kozijnen} kozijnen en ${luiken} luiken`]
                : []
        default:
            return [];
    }
}

export function validateHangPoints(row, hengtype, hoogte, direct = false) {
    switch (hengtype) {
        case HengType.T2:
        case HengType.L2:
        case HengType.H2:
            return hoogte >= 1600
            ? [(direct ? "" : `Situatie ${rowLetter(row)}: `) + `U heeft gekozen voor een hengtype met twee draaipunten. Bij de ingevulde luikhoogte (${hoogte}mm) is het advies om een hengtype met drie daaipunten te kiezen.`]
            : [];
        default:
            return [];
    }
}

export function validateKlampen(row, hengtype, luiktype, direct = false) {
    if (hengtype !== HengType.L3 && hengtype !== HengType.L2) {
        if (luiktype === LuikType.VENSTERLUIK_VISIBLE_CLAMS || luiktype === LuikType.VENSTERLUIK_INVISIBLE_CLAMS) {
            return [(direct ? "" : `Situatie ${rowLetter(row)}: `) + "Als u het luikbeslag op de klampen wilt monteren, kunt u het beste lang/staartgehengen gebruiken, L2 of L3."];
        }
    }
    return [];
}

export function hasValue(value) {
    return value != null && value !== "";
}

function rowLetter(value) {
    return String.fromCharCode(value + 'A'.charCodeAt(0));
}